import React, { useContext, useEffect, useState } from 'react';
import {
    Button, Modal, Row, Card, Col,
    Tooltip, Popover, Input
} from 'antd';
import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import CustomerProductContext from '../../ContextFiles/CustomerProductContext';
import SuccessModal from '../../SuccessModal/SuccessModal';
import ENVIRONMENT from '../../../../environments'
import axios from "axios";


const ImageListTypePreviews = (props) => {
    const isImageSelected = (image) => {
        return props.selectedProductImage.includes(image.url);
    }

    return (props.product_images?.length > 0 ?
        <>
            {props.product_images.map((image, index) => (
                <Card className={`product-img-grid-card comparison-modal display-flex ${isImageSelected(image)
                    ? `selected` : ``}`}
                    key={index} onClick={() => { props.selectImage(image.url) }}>
                    <img className='product-img-grid-img ' src={image.low_url} />
                </Card>
            ))}
        </> : <div className="manrope f-14 w-600 text-center w-100">No images available for selection</div>)
}

const InfoPopover = ({ content }) => (
    <Popover content={content} title={<span className="manrope f-12 w-700">Where to find this?</span>} trigger="hover">
        <InfoCircleOutlined style={{ marginLeft: 8, cursor: "pointer" }} />
    </Popover>
);

const WalmartImageSelectionModal = ({ visible, onCancel }) => {
    const { allProductImages, selectedImagesForUpload, setSelectedImagesForUpload } = useContext(CustomerProductContext);

    // State for Walmart specific data
    const [walmartItemId, setWalmartItemId] = useState('');
    const [walmartSku, setWalmartSku] = useState('');
    const [selectedImagePart, setSelectedImagePart] = useState({});
    const [walmartUploadSuccess, setWalmartUploadSuccess] = useState(false);
    const [walmartUploadError, setWalmartUploadError] = useState('');
    const [uploadingToWalmart, setUploadingToWalmart] = useState(false);

    const cancelSelectedComparisonImageModal = () => {
        onCancel();
        setSelectedImagesForUpload([]);
    }

    const selectImage = (url) => {
        let products = selectedImagesForUpload;
        if (products.includes(url)) {
            products = products.filter((ele) => ele != url)
        } else {
            if (products.length < 8) { // Walmart allows up to 8 images
                products.push(url);
            }
        }
        setSelectedImagesForUpload([...products]);
    }

    useEffect(() => {
        console.log("Selected Images for Walmart: ", selectedImagesForUpload)
        console.log("Selected Image Parts for Walmart: ", selectedImagePart)
    }, [selectedImagesForUpload])

    const changeItemId = (e) => {
        setWalmartItemId(e.target.value);
    }

    const onChangeWalmartSku = (e) => {
        setWalmartSku(e.target.value);
    }

    const uploadToWalmart = () => {
        setUploadingToWalmart(true);

        const payload = {
            sku: walmartSku,
            image_urls: selectedImagesForUpload,
            customer_username: localStorage.getItem('username')
        };

        axios.post(ENVIRONMENT.WALMART_UPLOAD_IMAGES, payload)
            .then(response => {
                setUploadingToWalmart(false);
                setWalmartUploadSuccess(true);
                setWalmartItemId(response?.data?.feed_id)
            })
            .catch(error => {
                setUploadingToWalmart(false);
                setWalmartUploadError(error.response?.data?.message || 'Failed to upload images to Walmart');
            });
    }

    return (
        <>
            <Modal
                className="comparison-image-popup"
                destroyOnClose={true}
                closable={true}
                title={<span className="manrope f-14 w-600">Select up to 8 images for your Walmart product listing</span>}
                visible={visible}
                onCancel={cancelSelectedComparisonImageModal}
                footer={[
                    <>
                        <div className="justify-in-end">
                            <Tooltip title={<span className="manrope f-12 white">Upload to Walmart</span>}>
                                <span>
                                    <Button className="modal-okay square font-14"
                                        disabled={uploadingToWalmart || !walmartSku || selectedImagesForUpload.length === 0}
                                        onClick={uploadToWalmart}>
                                        Upload {uploadingToWalmart && <LoadingOutlined />}
                                    </Button>
                                </span>
                            </Tooltip>
                        </div>
                        {walmartUploadError && <div className='manrope f-12 red mt-5'>{walmartUploadError}</div>}
                    </>]}>
                <>
                    <Row style={{ gap: 16 }}>
                        <Col span={7} className='mb-20 justify-in-start'>
                            <Input className='manrope f-14 w-400 placeholder black'
                                suffix={<InfoPopover content={<span className='manrope f-12 black-55'>Find SKU in Walmart Seller Center under Items {">"} All Items.</span>} />}
                                onChange={onChangeWalmartSku}
                                placeholder="SKU" />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={24} lg={24} xl={24}>
                            <div className='display-flex j-s a-s wrap sa-s gg-16 custom-scroll product-grid-list amz w-100'>
                                <ImageListTypePreviews
                                    setSelectedImagePart={setSelectedImagePart}
                                    selectedImagePart={selectedImagePart}
                                    setSelectedImagesForUpload={setSelectedImagesForUpload}
                                    product_images={allProductImages}
                                    selectImage={selectImage}
                                    selectedProductImage={selectedImagesForUpload}
                                />
                            </div>
                        </Col>
                    </Row>
                </>
            </Modal>
            <SuccessModal
                visible={walmartUploadSuccess}
                heading="Images Uploaded Successfully!"
                text={`Your product images have been successfully uploaded to Walmart. It may take a few minutes for them to reflect on your Walmart listing. In case of any issues please contact walmart support by providing this feed id: ${walmartItemId}`}
                footer={[
                    <div className="justify-in-center">
                        <Button style={{ margin: "auto" }} className="modal-okay square font-14" htmlType="submit" onClick={() => {
                            setWalmartUploadSuccess(false);
                            window.location.reload();
                        }}>
                            Okay
                        </Button>
                    </div>
                ]}
            />
        </>)
}

export default WalmartImageSelectionModal;
